enum SEARCH_PARAMS {
    classifierLocale = 'classifier-locale',
    level = 'level',
    searchPhrase = 'phrase',
    page = 'page',
    order = 'order',
    facetFilter = 'filter',
    subject = 'subject'
}

export default SEARCH_PARAMS;